/*
 * Ce fichier crée 2 plugins jQuery appelés "dndDraggable" et "dndDroppable" afin de gérer le DnD.
 * La page "jquery-dnd.html" permet de tester le fonctionnement, par exemple pour vérifier différents navigateurs
 */
(function($) {
	"use strict";

	// Un tableau de zones où l'on peut déposer
	var droppables = [];

	function Operation(event, draggable) {
		// Le "draggable" qui s'est activé
		this.draggable = draggable;
		// L'élément DOM que l'on commence à glisser
		this.draggableElement = $(event.target);
		// L'entrée de "droppables" qui s'activera
		this.droppable = null;
		// L'élément DOM que l'on est en train de survoler
		this.droppableElement = null;
		// L'objet représentant l'opération de DnD que l'on passera aux callback
		this.ui = {
			// Type de la donnée que l'on glisse
			type: this.draggable.type,
			// Elément DOM que l'on glisse
			draggable: this.draggableElement[0],
			// Texte à utiliser pour l'indicateur pendant le déplacement
			title: this.draggableElement.attr('data-draggable-title') || this.draggableElement.attr('title') || this.draggableElement.text(),
			// Conteneur de données alimenté dans Draggable.drag et récupéré dans Droppable.drop
			data: null,
			// Elément DOM sur lequel on dépose
			droppable: null
		};

		// Le div qui va suivre la souris pendant l'opération de DnD
		this.marker = $('<div class="dnd-indicator"><span /></div>');
		this.update(event); // Positionnement

		// Connecter les callback
		this.update = this.update.bind(this);
		this.stop = this.stop.bind(this);

		// Si pas de timeout on commence tout de suite
		if (this.draggable.timeoutBeforeDrag === 0)
			this.start(event);
		else {
			// Un timeout entre le mousedown et le début du DnD pour ne pas interpréter un clic comme un DnD
			var timeout = setTimeout(function() {
				// Si le timeout est atteint, on le remet à null pour ne pas conserver une valeur déjà utilisée
				timeout = null;
				// Lancer l'opération de DnD
				this.start(event);
			}.bind(this), this.draggable.timeoutBeforeDrag);

			// On détectera la fin du DnD quand la souris sera relâchée
			$(document.body).one('mouseup touchend', function() {
				// Si le timeout n'a pas eu lieu, c'était en fait un clic et pas un DnD
				if (timeout != null) {
					clearTimeout(timeout);
					timeout = null;
				}
			}.bind(this));
		}
		
		// On annule l'évènement pour éviter la sélection de texte bleue toute moche (en tout cas flagrant sous IE)
		// Ah bah non en fait, on ne peut pas car sinon, on ne peut plus sélectionner de ligne en grille Clients par exemple
		// Du coup, on cache la sélection bleue avec la classe "dnd-running" pendant le DnD puis on supprime avec "clearSelection" à la fin
		// event.preventDefault();
	}

	Operation.prototype.clearSelection = function(_event) {
		if (window.getSelection) {
			if (window.getSelection().empty) { // Chrome
				window.getSelection().empty();
			} else if (window.getSelection().removeAllRanges) { // Firefox
				window.getSelection().removeAllRanges();
			}
		} else if (document.selection) { // IE
			document.selection.empty();
		}
	};

	Operation.prototype.start = function(_event) {
		// Permettre la personnalisation du texte
		this.draggableElement.addClass('dnd-draggable-active');
		if (this.draggable.drag)
			this.draggable.drag(this.ui);
		// Insérer le div qui va suivre la souris
		this.marker.children('span').text(this.ui.title);
		if (this.ui.image)
			this.marker.prepend($('<img style="max-height: 24px; max-width: 24px; " />').attr('src', this.ui.image));
		else if (this.ui.icon)
			this.marker.prepend($('<i class="material-icons" />').text(this.ui.icon));
		this.marker.appendTo(document.body);
		// Activer les zones de drop
		this.activateDroppables();
		// Changer le curseur pendant le DnD
		$(document.body).addClass('dnd-running')
			// Ecouter les déplacements de la souris sur le body pour ne pas en rater
			.on('mousemove touchmove', this.update)
			// Ecouter le prochain "mouseup" sur le body aussi pour ne pas le rater
			.one('mouseup touchend', this.stop);
	};

	Operation.prototype.update = function(event) {
		var evtClientX, evtClientY;

		if (event.type.startsWith('touch')) {
			if (event.touches.length > 1) // On ne prend pas en compte s'il y a plusieurs doigts
				return;
			var touch = event.changedTouches[0];
			evtClientX = touch.clientX;
			evtClientY = touch.clientY;
		}
		else {
			evtClientX = event.clientX;
			evtClientY = event.clientY;
		}

		// Suivre la souris avec le marqueur
		this.marker.css({
			left: (evtClientX + 5) + 'px',
			top: (evtClientY + 5) + 'px',
		});
	};

	Operation.prototype.stop = function() {
		// Une fois la souris relâchée
		if (this.droppable) {
			this.droppable.drop(this.ui);
			this.leaveDroppable();
		}
		// Restaurer le style de départ de l'élément
		this.draggableElement.removeClass('dnd-draggable-active dnd-draggable-over');
		// Retirer l'indicateur de DnD
		this.marker.remove();
		// Désactiver les zones de drop
		this.deactivateDroppables();
		// Annuler la sélection bleue toute moche effectuée pendant le DnD mais cachée jusqu'au "mouseup"
		// On le fait avant de retirer la classe "dnd-running" qui cachait ce bleu pendant le DnD
		this.clearSelection();
		// Arrêter d'écouter les déplacements de la souris et restaurer le curseur
		$(document.body).removeClass('dnd-running').off('mousemove touchend', this.update);
	};

	Operation.prototype.activateDroppables = function() {
		// L'opération de DnD
		var self = this;
		// Récupération des coordonnées des rectangles où l'on peut dropper
		self.targets = [];
		for (var di = 0; di < droppables.length; di++) {
			var droppable = droppables[di], droppableTargets;

			// L'élément glissé est-il accepté par cette zone de drop
			var accept = true;
			if ($.isArray(droppable.accept))
				accept = droppable.accept.indexOf(this.ui.type) >= 0;
			else if (typeof droppable.accept === 'function')
				accept = droppable.accept(this.ui);

			// Si oui, ajouter les coordonnées des rectangles où l'on peut dropper
			if (accept) {
				droppableTargets = $(droppable.target).find(droppable.selector).addClass('dnd-droppable-active');
				for (var dti = 0; dti < droppableTargets.length; dti++) {
					var offset =  $(droppableTargets[dti]).offset();
					self.targets.push({
						x1: offset.left,
						x2: offset.left + droppableTargets[dti].offsetWidth,
						y1: offset.top,
						y2: offset.top + droppableTargets[dti].offsetHeight,
						droppable: droppable,
						element: droppableTargets[dti]
					});
				}
			}
		}

		// Si au moins une zone de drop
		if (self.targets.length > 0) {
			var listener = function(x, y) {
				for (var i = 0; i < self.targets.length; i++) {
					var t = self.targets[i];
					if (x >= t.x1 && x <= t.x2 && y >= t.y1 && y <= t.y2) {
						if (self.droppableElement !== t.element || self.droppable !== t.droppable) {
							if (self.droppableElement)
								self.leaveDroppable();
							self.enterDroppable(t.element, t.droppable);
						}
						break;
					}
				}
				// Si on est au bout de la liste, c'est qu'on est sorti des zones de drop
				if (i === self.targets.length && self.droppable) {
					self.leaveDroppable();
				}
			};
			var listenerMouse = function(event) { listener(event.clientX, event.clientY); };
			var listenerTouch = function(event) {
				if (event.touches.length > 1)
					return;
				var touch = event.changedTouches[0];
				listener(touch.clientX, touch.clientY);
			};
			// Ecouter les "mousemove" pour détecter si au passe au dessus d'une zone de drop
			$(document.body).on('mousemove', listenerMouse).on('touchmove', listenerTouch).one('mouseup touchend', function() {
				// ... jusqu'à ce que l'utilisateur relâche la souris
				$(document.body).off('mousemove', listenerMouse).off('touchmove', listenerTouch);
			});
		}
	};

	Operation.prototype.enterDroppable = function(element, droppable) {
		// Enregistrer la zone de drop
		this.droppable = droppable;
		this.droppableElement = element;
		this.ui.droppable = this.droppableElement;
		// Ajouter les classes pour permettre de personnaliser l'aspect
		this.draggableElement.addClass('dnd-draggable-over');
		$(this.droppableElement).addClass('dnd-droppable-over');
		if (this.droppable.classOnHover)
			$(this.droppableElement).addClass(this.droppable.classOnHover);
		this.marker.addClass('dnd-indicator-success');
	};

	Operation.prototype.leaveDroppable = function() {
		// Retirer les classes pour permettre de personnaliser l'aspect
		this.draggableElement.removeClass('dnd-draggable-over');
		$(this.droppableElement).removeClass('dnd-droppable-over');
		this.marker.removeClass('dnd-indicator-success');
		if (this.droppable.classOnHover)
			$(this.droppableElement).removeClass(this.droppable.classOnHover);
		// Désenregistrer la zone de drop
		this.droppable = null;
		this.droppableElement = null;
	};

	Operation.prototype.deactivateDroppables = function() {
		$(this.targets.map(function(t) { return t.element; })).removeClass('dnd-droppable-active dnd-droppable-over');
	};

	/**
	 * Voir aussi les classes CSS suivantes :
	 * - dnd-draggable : pour tous les draggables
	 * - dnd-draggable-active : pour le draggable que l'on a commencé à glisser
	 * - dnd-draggable-over : pour le draggable s'il est accepté par le droppable survolé
	 *
	 * Voir aussi les évènements suivantes :
	 * - dnd.start : quand ça démarre
	 * - dnd.stop : quand ça s'arrête
	 */
	function Draggable(target, options) {
		// Conteneur des éléments à glisser
		this.target = target;
		// Type de la donnée qui sera déplacée (pour contrôler le drop)
		this.type = options.type || null;
		// Sélecteur jQuery des éléments DOM que l'on glisse, au sein de "target"
		this.selector = options.selector || '.dnd-draggable';
		// Pour configurer le visuel et les données pour le drop
		this.drag = options.drag || $.noop;
		// délai en ms pour considérer qu'un click sur un élément déplaçable est le début d'un déplacement
		this.timeoutBeforeDrag = options.timeoutBeforeDrag || 300;
		// Quand on appuie avec la souris sur un élément "draggable"
		$(this.target).on('mousedown touchstart', this.selector, function(event) {
			new Operation(event, this);
		}.bind(this));
	}

	/**
	 * Voir aussi les classes CSS suivantes :
	 * - dnd-droppable : pour tous les droppables
	 * - dnd-droppable-active : pour les droppables acceptant l'élement glissé
	 * - dnd-droppable-over : pour le droppable survolé par un élement qu'il accepte
	 *
	 * Voir aussi les évènements suivantes :
	 * - dnd.activate : quand on commence un drag d'un élément autorisé
	 * - dnd.enter : quand on commence à survoler la cible avec un élement autorisé
	 * - dnd.leave : quand on quitte la cible avec un élement autorisé
	 * - dnd.deactivate : quand on arrête le drag d'un élément autorisé
	 */
	function Droppable(target, options) {
		// Conteneur de la zone où l'on peut déposer
		this.target = target;
		// Tableau des types de donnée acceptés par cette cible
		this.accept = options.accept || null;
		// Sélecteur jQuery des éléments DOM où l'on peut déposer, au sein de "target"
		this.selector = options.selector || '.dnd-droppable';
		// Pour réagir quand on dépose l'élément à un endroit autorisé
		this.drop = options.drop;
		// Pour mettre un style aux éléments quand on les survole avec un draggable
		this.classOnHover = options.classOnHover;
		if (!options.drop)
			throw new Error('Missing drop option for selector "' + this.selector + '"');
		// Ajout au tableau contenant tous les droppables
		droppables.push(this);
	}

	Droppable.prototype.destroy = function() {
		droppables.splice(droppables.indexOf(this), 1);
	};

	function addPlugin(name, Constructor) {
		// Composant en jQuery, proposant 3 appels possibles
		$.fn[name] = function(params) {
			// 1. Création avec .xxx({ ... });
			if (typeof params === 'object') {
				return this.each(function() {
					$(this).data(name, new Constructor(this, params));
				});
			}

			// 2. Récupération avec .xxx();
			if (typeof params === 'undefined') {
				return this.data(name);
			}

			// 3. Destruction avec .xxx('destroy');
			if (params === 'destroy') {
				return this.each(function() {
					var self = $(this), component = self.data(name);
					if (component) {
						component.destroy();
						self.removeData(name);
					}
				});
			}

			// Erreur sinon
			throw new Error('Paramètre non supporté pour le composant ' + name + ' : ' + params);
		};
	}

	addPlugin('dndDraggable', Draggable);
	addPlugin('dndDroppable', Droppable);

})(window.jQuery);
